import { Controller } from "@hotwired/stimulus";
import YoutubePlayer from "youtube-player";
export default class extends Controller {
  static targets = "videoPlayer"

  show() {
    this.videoPlayerTarget.classList.remove("hidden")
  }

  hide() {
    this.videoPlayerTarget.classList.add("hidden")
  }

}
